export default __webpack_public_path__ + "static/media/clear_day.44717f58.svg";